export const environment = {
  production: true,
  buildId: '3991869289424141',
  configFile: 'config.json',
};
